export const load = () => ({
	title: 'How to Measure a Window Diagonal',
	showTitle: true,
});
